import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=0de2f61b&scoped=true"
import script from "./Office.vue?vue&type=script&lang=js"
export * from "./Office.vue?vue&type=script&lang=js"
import style0 from "./Office.vue?vue&type=style&index=0&id=0de2f61b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de2f61b",
  null
  
)

export default component.exports